import {
  ON_CONVERSATION_CREATE_EVENT_TYPE,
  ON_MESSAGE_SENT_EVENT_TYPE,
  ON_MESSAGE_RECEIVED_EVENT_TYPE,
  ON_UNREAD_COUNT_CHANGE_EVENT_TYPE,
  ON_CONVERSATION_ENDED_EVENT_TYPE,
  ON_CONVERSATION_UNENDED_EVENT_TYPE,
  ON_SATISFACTION_RECEIVED_EVENT_TYPE,
  ON_AGENT_TYPING_ACTIVITY,
  ON_LOGIN,
  ON_LOGOUT,
  ON_ASSISTANT_ENDED_EVENT_TYPE,
  ON_CONVERSATION_MERGED_EVENT_TYPE,
} from 'core/constants';
import { SatisfactionCallbackResponse } from 'core_main/api/satisfaction/types';
import {
  ConversationMergedCallbackResponse,
  OnUnreadCountChangeCallbackResponse,
} from 'core_main/pubnub/types';
import { LoginCallbackResponse } from 'core_main/sdk/login/types';
import { ConversationCallbackResponse } from 'core_main/sdk/types';
import { getStore } from 'core_main/store';
import { KustomerEventTypes } from '../types';

export const validateEventType = (type: KustomerEventTypes) => {
  const validEvents: KustomerEventTypes[] = [
    ON_CONVERSATION_CREATE_EVENT_TYPE,
    ON_MESSAGE_SENT_EVENT_TYPE,
    ON_MESSAGE_RECEIVED_EVENT_TYPE,
    ON_UNREAD_COUNT_CHANGE_EVENT_TYPE,
    ON_CONVERSATION_ENDED_EVENT_TYPE,
    ON_CONVERSATION_UNENDED_EVENT_TYPE,
    ON_ASSISTANT_ENDED_EVENT_TYPE,
    ON_SATISFACTION_RECEIVED_EVENT_TYPE,
    ON_AGENT_TYPING_ACTIVITY,
    ON_LOGIN,
    ON_LOGOUT,
    ON_CONVERSATION_MERGED_EVENT_TYPE,
  ];

  if (!validEvents.includes(type)) {
    console.error(`Provided Kustomer event type is invalid: ${type}`);
    return false;
  }

  return true;
};

export type RunListenersForEventCallbackResponse =
  | ConversationCallbackResponse
  | SatisfactionCallbackResponse
  | OnUnreadCountChangeCallbackResponse
  | LoginCallbackResponse
  | ConversationMergedCallbackResponse;

export const runListenersForEvent = (
  event: KustomerEventTypes,
  response?: RunListenersForEventCallbackResponse | null,
  error?: Error,
) => {
  const { listeners } = getStore();

  const callbacks = listeners[event];

  if (!callbacks?.length) return;

  callbacks.forEach((callback) => {
    if (!response && !error) {
      callback();
    } else {
      callback(response, error);
    }
  });
};
